/* eslint react/prop-types: off */
import { useState } from 'react';
import './reclamo.css';
import { DocSinAbrir } from './DocsSinAbrir';
import { useCookies } from 'react-cookie';
export function DocumentosPersonales({ setPestania, reclamo, theme, estadoDocs, setEstadoDocs, obs, setObs, modoEliminar, docsSeleccionados, setDocsSeleccionados, setModoEliminar }) {
  const [cookies] = useCookies(['user']);
  const [doc, setDoc] = useState(0);
  const resultado = {
    aprobado: { count: 0, campos: [] },
    devolucion: { count: 0, campos: [] },
    devuelto: { count: 0, campos: [] },
    pendiente: { count: 0, campos: [] },
    total: { count: 0 },
  };
  const docs = reclamo?.docs || {};
  const estadosExcluidos = ['estadoVtv', 'estadoDenunciaPolicial', 'estadoFormulario08', 'estadoDanioPropiedad', 'estadoFotosAseguradoAGS', 'estadoNoDestruccionTotal', 'estadoCroquis'];
  for (const [campo, valor] of Object.entries(docs)) {
    // Filtrar los campos que están en la lista de estadosExcluidos
    if (estadosExcluidos.includes(campo)) continue;
    // Lógica de aprobación, devolución y pendiente
    if (valor === 904) {
      resultado.aprobado.count++;
      resultado.aprobado.campos.push(campo);
      resultado.total.count++;
    } else if (valor === 903) {
      resultado.devolucion.count++;
      resultado.devolucion.campos.push(campo);
      resultado.total.count++;
    } else if (valor === 902) {
      resultado.pendiente.count++;
      resultado.pendiente.campos.push(campo);
      resultado.total.count++;
    } else if (valor === 905) {
      resultado.devuelto.count++;
      resultado.devuelto.campos.push(campo);
      resultado.total.count++;
    }
  }
  return (
    <>
      <article className={theme === 1 ? 'botonDesplegableAbierto' : 'botonDesplegableAbiertoDark'}>
        <div className='d-flex align-items-center' style={{ paddingTop: '32px' }}>
          <h4 className={theme === 1 ? 'tituloBotonDesplegable' : 'tituloBotonDesplegableDark'}>
            Docs Obligatorios {resultado.total.count}/7 CARGADOS - {resultado.pendiente.count} PENDIENTES - {resultado.devolucion.count} DEVOLUCION - {resultado.devuelto.count} REINGRESO -{' '}
            {resultado.aprobado.count} APROBADO
          </h4>
          {setPestania && (
            <i className={theme === 1 ? 'bi bi-chevron-down' : 'bi bi-chevron-down text-white'} style={{ marginLeft: 'auto', fontSize: '20px', cursor: 'pointer' }} onClick={() => setPestania(0)}></i>
          )}
        </div>
        <div className='d-flex w-100' style={{ gap: '15px', marginTop: '10px' }}>
          <DocSinAbrir
            key={`${reclamo?.id}-1`}
            id={reclamo?.id}
            documento={1}
            link={reclamo.archivos?.denunciaAdministrativa?.join(',') || ''}
            ultMod={reclamo.docs?.ultModDenunciaAdministrativa || ''}
            theme={theme}
            estadoDocs={estadoDocs}
            setEstadoDocs={setEstadoDocs}
            obs={obs}
            setObs={setObs}
            modoEliminar={modoEliminar}
            docsSeleccionados={docsSeleccionados}
            setDocsSeleccionados={setDocsSeleccionados}
            setModoEliminar={setModoEliminar}
          />
          <DocSinAbrir
            key={`${reclamo?.id}-2`}
            id={reclamo?.id}
            documento={2}
            link={reclamo.archivos?.registro?.join(',') || ''}
            ultMod={reclamo.docs?.ultModRegistro || ''}
            theme={theme}
            estadoDocs={estadoDocs}
            setEstadoDocs={setEstadoDocs}
            obs={obs}
            setObs={setObs}
            modoEliminar={modoEliminar}
            docsSeleccionados={docsSeleccionados}
            setDocsSeleccionados={setDocsSeleccionados}
            setModoEliminar={setModoEliminar}
          />
        </div>
        <div className='d-flex w-100' style={{ gap: '15px', marginTop: '10px' }}>
          <DocSinAbrir
            key={`${reclamo?.id}-3`}
            id={reclamo?.id}
            documento={3}
            link={reclamo.archivos?.cedula?.join(',') || ''}
            ultMod={reclamo.docs?.ultModCedula || ''}
            theme={theme}
            estadoDocs={estadoDocs}
            setEstadoDocs={setEstadoDocs}
            obs={obs}
            setObs={setObs}
            modoEliminar={modoEliminar}
            docsSeleccionados={docsSeleccionados}
            setDocsSeleccionados={setDocsSeleccionados}
            setModoEliminar={setModoEliminar}
          />
          <DocSinAbrir
            key={`${reclamo?.id}-4`}
            id={reclamo?.id}
            documento={4}
            link={reclamo.archivos?.presupuesto?.join(',') || ''}
            ultMod={reclamo.docs?.ultModPresupuesto || ''}
            theme={theme}
            estadoDocs={estadoDocs}
            setEstadoDocs={setEstadoDocs}
            obs={obs}
            setObs={setObs}
            modoEliminar={modoEliminar}
            docsSeleccionados={docsSeleccionados}
            setDocsSeleccionados={setDocsSeleccionados}
            setModoEliminar={setModoEliminar}
          />
        </div>
        <div className='d-flex w-100' style={{ gap: '15px', marginTop: '10px' }}>
          <DocSinAbrir
            key={`${reclamo?.id}-5`}
            id={reclamo?.id}
            documento={5}
            link={reclamo.archivos?.fotos?.join(',') || ''}
            ultMod={reclamo.docs?.ultModFotos || ''}
            theme={theme}
            estadoDocs={estadoDocs}
            setEstadoDocs={setEstadoDocs}
            obs={obs}
            setObs={setObs}
            modoEliminar={modoEliminar}
            docsSeleccionados={docsSeleccionados}
            setDocsSeleccionados={setDocsSeleccionados}
            setModoEliminar={setModoEliminar}
          />
          <DocSinAbrir
            key={`${reclamo?.id}-6`}
            id={reclamo?.id}
            documento={6}
            link={reclamo.archivos?.cobertura?.join(',') || ''}
            ultMod={reclamo.docs?.ultModCobertura || ''}
            theme={theme}
            estadoDocs={estadoDocs}
            setEstadoDocs={setEstadoDocs}
            obs={obs}
            setObs={setObs}
            modoEliminar={modoEliminar}
            docsSeleccionados={docsSeleccionados}
            setDocsSeleccionados={setDocsSeleccionados}
            setModoEliminar={setModoEliminar}
          />
        </div>
        <div className='d-flex w-100' style={{ gap: '15px', marginTop: '10px' }}>
          <div className='w-100'>
            <DocSinAbrir
              key={`${reclamo?.id}-7`}
              id={reclamo?.id}
              documento={10}
              link={reclamo.archivos?.lesiones?.join(',') || ''}
              ultMod={reclamo.docs?.ultModLesiones || ''}
              theme={theme}
              estadoDocs={estadoDocs}
              setEstadoDocs={setEstadoDocs}
              obs={obs}
              setObs={setObs}
              modoEliminar={modoEliminar}
              docsSeleccionados={docsSeleccionados}
              setDocsSeleccionados={setDocsSeleccionados}
              setModoEliminar={setModoEliminar}
            />
          </div>
          <div className='w-100'></div>
        </div>
      </article>
    </>
  );
}
